import { render } from "./FileDiff.vue?vue&type=template&id=0ad03138&scoped=true"
import script from "./FileDiff.vue?vue&type=script&lang=js"
export * from "./FileDiff.vue?vue&type=script&lang=js"

import "./FileDiff.vue?vue&type=style&index=0&id=0ad03138&lang=scss&scoped=true"
import "./FileDiff.vue?vue&type=style&index=1&id=0ad03138&scoped=true&lang=scss"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ad03138"]])

export default __exports__